export default __webpack_public_path__ + "static/media/Renfert.ac632b18.png";